import apiClient from './axiosConfig';
import { API_ENDPOINTS } from '../constants';

const analyticsApi = {
  getSummaryStats: async (params) => {
    try {
      const response = await apiClient.get(API_ENDPOINTS.ANALYTICS_SUMMARY_STATS, { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getVisitorsByDate: async (params) => {
    try {
      const response = await apiClient.get(API_ENDPOINTS.ANALYTICS_VISITORS_BY_DATE, { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getVisitorsByCountry: async (params) => {
    try {
      const response = await apiClient.get(API_ENDPOINTS.ANALYTICS_VISITORS_BY_COUNTRY, { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getTrafficSources: async (params) => {
    try {
      const response = await apiClient.get(API_ENDPOINTS.ANALYTICS_TRAFFIC_SOURCES, { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getMostVisitedPages: async (params) => {
    try {
      const response = await apiClient.get(API_ENDPOINTS.ANALYTICS_MOST_VISITED_PAGES, { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getTopOperatingSystems: async (params) => {
    try {
      const response = await apiClient.get(API_ENDPOINTS.ANALYTICS_TOP_OPERATING_SYSTEMS, { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getTopBrowsers: async (params) => {
    try {
      const response = await apiClient.get(API_ENDPOINTS.ANALYTICS_TOP_BROWSERS, { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default analyticsApi;